import common from "./common";
import user from "./user";
import cameraGrapher from "./camera_grapher";

export default {
  common,
  user,
  cameraGrapher,
};